import axios from 'axios';
import DEFINES from '@/defines';

const userCountryCode = {
  methods: {
    async getUserCountryCode () {
      // Not calling IPData api for dev Envs will save quota
      var envIndex = ['stage', 'development', 'test'].indexOf (
        DEFINES.NODE_ENV
      );

      if (envIndex != -1) {
        return DEFINES.DEFAULT_COUNTRY_CODE;
      }

      const IPDATA_BASE_URL = 'https://api.ipdata.co';
      const API_KEY = DEFINES.IPDATA_API_KEY;

      let response = await axios
        .get (`${IPDATA_BASE_URL}?api-key=${API_KEY}`)
        .then (response => response.data)
        .catch (error => {
          console.error (error);
        });

      return response && response.country_code
        ? response.country_code
        : DEFINES.DEFAULT_COUNTRY_CODE;
    },
  },
};

export {userCountryCode};
